var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowToPlayPrize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.0752 26.9509L33.1498 2.93665L30.225 0L27.2883 2.92481L2.93666 27.1877L0 30.1125L2.92481 33.0432L26.8502 57.0634L29.775 60L32.7117 57.0752L57.0633 32.8123L60 29.8875L57.0752 26.9509ZM30.2013 7.16992L52.8301 29.8816L29.7987 52.8301L7.16993 30.1125L30.2013 7.16992Z",
    fill: "url(#paint0_linear_3213_3356)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7694 54.6648L5.32768 30.1323L13.411 22.0767L13.4111 22.0767L30.2212 5.32962L47.7322 22.9095L54.6629 29.8678L29.7694 54.6648Z",
    fill: "white",
    stroke: "#0A0A0A",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3213_3356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3543 38.6116H18.9502C18.065 38.6116 17.354 37.8943 17.354 37.0014V23.6514C17.354 22.8536 17.9344 22.1656 18.7252 22.0558C26.3432 20.9946 33.9612 20.9946 41.5792 22.0558C42.3627 22.1656 42.9504 22.8536 42.9504 23.6514V37.0014C42.9504 37.887 42.2394 38.6116 41.3543 38.6116Z",
    fill: "#000212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9504 28.7675H17.354",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0991 28.7675V38.6116",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4797 28.7675V38.6116",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4537 26.4641H28.8507C27.5329 26.4641 26.4646 27.5324 26.4646 28.8502C26.4646 30.168 27.5329 31.2363 28.8507 31.2363H31.4537C32.7715 31.2363 33.8398 30.168 33.8398 28.8502C33.8398 27.5324 32.7715 26.4641 31.4537 26.4641Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3213_3356",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B284F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECD3E8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3213_3356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.5964,
    height: 17.3535,
    fill: "white",
    transform: "translate(17.3535 21.2581)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToPlayPrize);
export default __webpack_public_path__ + "static/media/how-to-play_prize.946b3b90c2e1810cd27cac9d394bf038.svg";
export { ForwardRef as ReactComponent };